<template>
<div tabindex="0" class="e-card" id="stage">
  <div class="e-card-title" >Update Email Stage Template</div>
    <div>
      <div class="e-card-content" v-if="emailStage">
        <div class="form-row">
          <div style="color: black; font-size: 14px; ">
                  <b>Group :</b> {{ emailStage.stageGroup }}
                </div>
        </div>
        <div class="form-row">
          <p style="color: black; font-size: 14px; ">
            <b>Stage :</b> {{ emailStage.stage }}
          </p>
        </div>
        <div class="form-row">
        <p style="color: black; font-size: 14px; width: 100%;">
          <b>Send To :  </b>
            <ejs-textbox ref="refSendTo"
              height="340"
              width="60%"
              placeholder=""
              v-model="emailStage.sendTo"
              :maxlength="250"
              >
            </ejs-textbox>
          </p>
        </div>
        <div class="form-row">
          <p style="color: black; font-size: 14px; width: 100%;">
          <b>CC To :  </b>
            <ejs-textbox ref="refCCTo"
              height="340"
              width="60%"
              placeholder=""
              v-model="emailStage.ccTo"
              :maxlength="250"
              >
            </ejs-textbox>
          </p>
  </div>
        <div class="form-row">
          <p style="color: black; font-size: 14px; ">
                  <b>Description:</b> {{ emailStage.description }}
                </p>
        </div>
        <div class="form-row">
            <div style="width:150px;" class="form-row-input">
              <label><b><font color="black">InActive/Active :</font></b></label>
            </div>
            <div style="width:150px;" class="form-row-input">
              <ejs-switch id="status" v-model="emailStage.isActive"
                          ref="refStatus"
                          :checked="emailStage.isActive"></ejs-switch>
            </div>
        </div>
        <div class="form-row">
           <div style="width:80%;" class="form-row-input">
            <p style="color: black; font-size: 14px; "><b>Subject Line :</b>
            <scc-input-validator :rules="[requiredRule]"
                :value="emailStage.subjectLine"
                @validate="v => this.isSubjectLineValid=v">
            <ejs-textbox
                v-model="emailStage.subjectLine"
            />
            </scc-input-validator>
          </p>
          </div>
        </div>
        <div style="width:80%;" class="form-row-input">
          <b><font color="black">Email Body :</font></b>
        </div>
        <div class="form-row">
            <div style="width:80%;" class="form-row-input">
              <scc-input-validator :rules="[requiredRule]"
                :value="emailStage.emailTemplate"
                @validate="v => this.isTemplateValid=v">
                <ejs-richtexteditor ref="refTemplate"
                height="340"
                width="100%"
                float-label-type="Always"
                placeholder="Email Body"
                :toolbarSettings="toolbarSettings"
                v-model="emailStage.emailTemplate"
                >
                </ejs-richtexteditor>
              </scc-input-validator>
            </div>
        </div>
        <div style="width:100%;">
            <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                        cssClass="e-info margin-button">Submit</ejs-button>
            <ejs-button v-on:click.native="onCancelButtonClick"
                        cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  Image,
  HtmlEditor,
  QuickToolbar,
} from '@syncfusion/ej2-vue-richtexteditor';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { RadioButtonPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '@/components/base/scc-input-validator.vue';
import { FETCH_EMAIL_STAGE, POST_EMAIL_STAGE } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(RichTextEditorPlugin);
Vue.use(SwitchPlugin);

export default {
  name: 'EmailStageTemplateEdit',
  provide: {
    richtexteditor: [Toolbar, Link, Count, Image, HtmlEditor, QuickToolbar],
  },
  components: {
    SccInputValidator,
  },
  data() {
    return {
      id: null,
      emailStage: null,
      isSubjectLineValid: false,
      isTemplateValid: false,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      toolbarSettings: {
        type: 'Expand',
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
          'SourceCode', 'FullScreen', '|', 'Undo', 'Redo',
        ],
      },
    };
  },
  mounted() {
    if (this.$route.params.id !== '0') {
      this.id = this.$route.params.id;
      this.getEmailStage().then(() => {
        this.emailStage = this.$store.getters.emailStage;
        // console.log('emailstage--:', this.$store.getters);
      });
    } else {
      this.id = '';
    }
  },
  created() {
  },

  computed: {
  },

  methods: {
    onCancelButtonClick() {
      this.$router.push('/email-stage-list');
    },
    async onSubmitButtonClick(e) {
      if (this.id === null || this.id === '') {
        e.Cancel = true;
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Missing primary key, cannot update!',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$refs.notifierRef.show();
        return;
      }
      let formDataFail = false;
      let errorMessage = '';
      if (this.emailStage.subjectLine === null || this.emailStage.subjectLine === '') {
        formDataFail = true;
        errorMessage += 'Please check Subject Line!<br>';
      }
      if (this.emailStage.emailTemplate === null || this.emailStage.emailTemplate === '') {
        formDataFail = true;
        errorMessage += 'Please check Email Template!<br>';
      }
      if (formDataFail) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$refs.notifierRef.show();
        return;
      }
      try {
        const data = this.emailStage;
        await this.$store.dispatch(POST_EMAIL_STAGE, { data });
        this.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Email template saved.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
        this.$router.push('/email-stage-list');
      } catch (error) {
        // console.log(`new price error: ${error.message}`);
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please verify the form data.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async getEmailStage() {
      try {
        if (this.id != null && this.id !== '') {
          const stageId = this.id;
          await this.$store.dispatch(FETCH_EMAIL_STAGE, { stageId });
        }
      } catch (err) {
        console.error('user accounts err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
  },
};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 @import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
 .e-card-content {
  margin: 0% !important;
}
</style>
